module.exports = __webpack_public_path__ + "img/Mat Sabu.72e04340.jpg";